import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { Icon } from "../Icon";
import { EqualHeightElement } from "../EqualHeight/EqualHeightElement";

import styles from "./ProductTile.scss";

const ProductTileIcon = forwardRef(
  ({ icon, iconWrapperProps, placeholder, customClass, ...restProps }, ref) => {
    return (
      <EqualHeightElement name="ProductTileIcon" placeholder={placeholder}>
        <div
          ref={ref}
          className={cx(styles.iconWrapper, customClass)}
          {...restProps}
        >
          <Icon
            icon={icon}
            size={Icon.Size.parent}
            wrapperProps={iconWrapperProps}
          />
        </div>
      </EqualHeightElement>
    );
  }
);

ProductTileIcon.displayName = "ProductTile.Icon";

ProductTileIcon.propTypes = {
  icon: PropTypes.elementType.isRequired,
  placeholder: EqualHeightElement.propTypes.placeholder,
  customClass: PropTypes.string,
  iconWrapperProps: PropTypes.objectOf(PropTypes.any),
};

ProductTileIcon.defaultProps = {
  placeholder: EqualHeightElement.defaultProps.placeholder,
  customClass: undefined,
  iconWrapperProps: null,
};

export default ProductTileIcon;
